exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-preview[data-v-9e74fab4]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:20px}img.preview[data-v-9e74fab4]{width:200px;background-color:#fff;border:1px solid #ddd;padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e74fab4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/document_management/upload_document_form.vue
// module id = 1319
// module chunks = 3